import LeaseApplicationService from 'aurora-composition/services/leaseApplication';
import PropertiesService from 'aurora-composition/services/propertyService';
import WorkflowService from 'aurora-composition/services/workflowService';
import history from 'aurora-utils/history';
import { getPropertType, getTitle, getPropertyTitle, convertStringToDate } from 'aurora-utils/utils';
import {
  CleverTapServicesPreValidation,
  CleverTapServicesLeaseClosureInitiateFlow,
  CleverTapServicesLeaseCancellationInitiateFlow,
  CleverTapCancelApplicationDetails,
  CleverTapCancelApplicationDetailsSuccess,
  CleverTapCancelApplicationDetailsFailure,
  CleverTapTaskReviewApplicationReturnSuccessEvent,
  //  CleverTapGenericServiceSubmitEvent,
  CleverTapTaskReviewApplicationAcceptEvent,
  CleverTapTaskReviewApplicationAcceptSuccessEvent,
  CleverTapTaskReviewApplicationAcceptFailureEvent,
  // CleverTapTaskReviewApplicationRejectEvent,
  CleverTapTaskReviewApplicationRejectSuccessEvent,
  CleverTapTaskReviewApplicationRejectFailureEvent,
  CleverTapTaskReviewApplicationTerminateEvent,
  CleverTapTaskReviewApplicationTerminateSuccessEvent,
  CleverTapTaskReviewStatusViewEvent,
  CleverTapTaskReviewApplicationCancelEvent,
  CleverTapTaskReviewApplicationInItCloseEvent,
  CleverTapTaskReviewApplicationResubmitEvent,
  CleverTapServicesStartApplication,
  CleverTapTaskReviewApplicationReturnEvent,
} from 'aurora-utils/cleverTap.eventhelper';

import formatPreValidationForClevertap from 'aurora-utils/clevertap.validation.formatter';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import * as types from './constants';

export const fetchApplicationSuccess = application => ({
  type: types.FETCH_APPLICATION_SUCCESS,
  payload: {
    application,
  },
});

export const fetchApplicationError = error => ({
  type: types.FETCH_APPLICATION_ERROR,
  payload: {
    error,
  },
});
// fetch Document
export const fetchDocument = async applicationId => {
  try {
    const responseDocument = await WorkflowService.fetchDocuments({
      applicationId,
    });
    return responseDocument?.data?.result || responseDocument?.result || null;
  } catch (e) {
    return null;
  }
};
// fetch property
export const fetchPropertyDetail = async plotId => {
  try {
    const responseProperty = await PropertiesService.fetchPropertyLease(plotId);
    const data = responseProperty?.result;

    const propertyDetail = {};
    const en = {};
    const ar = {};
    if (data) {
      en.type = getPropertType(data?.propertyType);
      ar.type = getPropertType(data?.propertyType);

      en.title = data?.unitRegistrationNumber;
      en.subtitle = getPropertyTitle(data);
      ar.title = data?.unitRegistrationNumber;
      ar.subtitle = getPropertyTitle(data);

      ar.contract = data?.contractDetail;
      en.contract = data?.contractDetail;

      en.unitArea = data?.unitArea;
      en.muncipality = data?.muncipalityEn;
      en.plotNumber = data?.plotNumber;
      en.district = data?.districtEn;
      en.buildingNumber = data?.buildingNumber;
      en.plotID = data?.propertyID;
      en.municipalityID = data?.municipalityID;
      en.location = data?.location;
      en.community = data?.communityEn;
      en.propertyType = data?.propertyType;
      en.plotAddress = data?.plotAddress;
      en.muncipality = data?.muncipalityEn;
      en.unitNumber = data?.unitNumber;
      en.unitReg = data?.unitRegistrationNumber;
      en.unitUsageType = data?.unitUsageTypeEn;
      ar.unitUsageType = data?.unitUsageTypeAr;
      en.buildingUsage = data?.buildingUsageEn;
      ar.buildingUsage = data?.buildingUsageAr;
      en.bedroom = data?.bedroomCount;
      ar.bedroom = data?.bedroomCount;
      ar.unitReg = data?.unitRegistrationNumber;
      ar.plotNumber = data?.plotNumber;
      ar.unitNumber = data?.unitNumber;
      ar.muncipality = data?.muncipalityAr;
      ar.buildingNumber = data?.buildingNumber;
      ar.district = data?.districtAr;
      ar.plotID = data?.propertyID;
      ar.municipalityID = data?.municipalityID;
      ar.location = data?.location;
      ar.community = data?.communityAr;
      ar.propertyType = data?.propertyType;
      ar.plotAddress = data?.plotAddress;
      ar.municipalityNameAr = data?.muncipalityAr;
      ar.unitArea = data?.unitArea;
    }
    propertyDetail.en = en;
    propertyDetail.ar = ar;
    propertyDetail.ownerships = data?.ownerships;

    return propertyDetail;
  } catch (e) {
    return null;
  }
};

export const redirection = (propertyDetail, application, id, url, paymentType = null) => {
  const propertyObj = {};
  // eslint-disable-next-line no-param-reassign
  application.propertyDetail = propertyDetail;
  const enObj = {
    application,
    plotId: propertyDetail?.en?.plotID,
    applicationId: id,
    contract: propertyDetail?.en?.contract,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    title: getTitle(propertyDetail?.en?.type, propertyDetail?.en),
    type: propertyDetail?.en?.type,
    paymentType,
    property: propertyDetail,
    tenantName: application?.individual?.tenName || application?.company?.companyName || null,
    duration: `${moment(application?.rental?.contStartDate).format('DD/MM/YYYY')} - ${moment(
      application?.rental?.contEndDate,
    )
      .add(application?.rental?.gracePeriod || 0, 'days')
      .format('DD/MM/YYYY')}`,
    showSubTitle: application?.showSubTitle,
  };
  const arObj = {
    application,

    plotId: propertyDetail?.ar?.plotID,
    applicationId: id,
    property: propertyDetail,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    contract: propertyDetail?.ar?.contract,
    title: getTitle(propertyDetail?.ar?.type, propertyDetail?.ar),
    type: propertyDetail?.ar?.type,
    paymentType,
    tenantName: application?.individual?.tenName || application?.company?.companyName || null,
    duration: `${moment(application?.rental?.contStartDate).format('DD/MM/YYYY')} - ${moment(
      application?.rental?.contEndDate,
    )
      .add(application?.rental?.gracePeriod || 0, 'days')
      .format('DD/MM/YYYY')}`,
    showSubTitle: application?.showSubTitle,
  };
  propertyObj.en = enObj;
  propertyObj.ar = arObj;
  history.replace({
    pathname: url,
    state: { ...propertyObj },
  });
};
export const fetchApplication = (
  id,
  actionParams = null,
  type = 'tenant',
  isPayment = false,
  propertyId = null,
  secondPartyApprovalRequired,
  status,
) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.FETCH_APPLICATION });

    if (type === 'closure' || type === 'cancellation' || type === 'termination') {
      let appType = 'LEASE_CLOSURE';
      if (type === 'cancellation') {
        appType = 'LEASE_CANCELLATION';
      } else if (type === 'termination') {
        appType = 'LEASE_TERMINATION_COURT_ORDER';
      }
      const params = {
        applicationType: appType,
        contractId: id,
      };
      const validationParams = {
        applicationType: appType,
        plotId: propertyId,
        contractId: id,
      };
      CleverTapServicesStartApplication({
        property_id: propertyId,
        application_type: appType,
      });
      const validation = await WorkflowService.checkValidation(validationParams);
      if (!isEmpty(validation?.result)) {
        CleverTapServicesPreValidation({
          property_id: propertyId,
          application_type: appType,
          contractId: id,
          ...formatPreValidationForClevertap(validation?.result),
        });
        history.replace('/app/services/validations', { ...validation?.result });
        return;
      }
      CleverTapServicesPreValidation({
        property_id: propertyId,
        application_type: appType,
        contractId: id,
      });
      CleverTapServicesStartApplication({
        property_id: propertyId,
        application_type: appType,
      });
      const response = await WorkflowService.registerApplication(params);
      if (appType === 'LEASE_CLOSURE') CleverTapServicesLeaseClosureInitiateFlow();
      if (appType === 'LEASE_CANCELLATION') CleverTapServicesLeaseCancellationInitiateFlow();
      const res = response?.data?.result || response?.result;

      // eslint-disable-next-line no-param-reassign
      id = res?.id;

      // }
    }
    // fetch application
    const response = await LeaseApplicationService.fetchLeaseApplication(id);
    const res = response?.data?.result || response?.result;

    // document
    const documents = await fetchDocument(id);

    // property
    let propertyDetail = {};
    if (res?.multipleUnit !== true) {
      propertyDetail = await fetchPropertyDetail(res?.property?.plotId);
    }
    const cleverTapOwnerPayload = {};
    res?.owners?.forEach((owner, index) => {
      const currentIndex = index;
      cleverTapOwnerPayload['ownerUserId_' + currentIndex] = owner?.eidOrUnified;
      cleverTapOwnerPayload['ownerNameTradeLicenseNumber_' + currentIndex] = owner?.tradeLicenseNumber;
      cleverTapOwnerPayload['ownerNameEn_' + currentIndex] = owner?.ownerNameEn;
      cleverTapOwnerPayload['ownerNameAr_' + currentIndex] = owner?.ownerNameAr;
      cleverTapOwnerPayload['ownerNameEmail_' + currentIndex] = owner?.email;
      cleverTapOwnerPayload['ownerNamePhone_' + currentIndex] = owner?.phoneNumber;
      cleverTapOwnerPayload['ownerRejectionReason_' + currentIndex] = owner?.rejectionReason;
      cleverTapOwnerPayload['ownerPartyType_' + currentIndex] = owner?.partyType;
    });
    const cleverTapGenericPayload = {
      screenName: 'screen_task_details_view',
      applicationStatus: res?.applicationDetails?.applicationStatus,
      applicationType: res?.applicationDetails?.applicationType,
      applicationId: res?.applicationId,
      applicationNumber: res?.applicationDetails?.applicationNumber,
      applicationStep: status,
      progressStatus: res?.applicationDetails?.progressStatus,
      contractNumber: res?.contractNo,
      contractStartDate: res?.contractDetails?.dateOfSale,
      contractEndDate: res?.contractDetails?.projectCompletionDate,
      initiatorName: res?.applicationDetails?.initiatorName,
      initiatorNameAr: res?.applicationDetails?.initiatorNameAr,
      gracePeriod: res?.rental?.gracePeriod,
      ContractActualEndDate: convertStringToDate(res?.rental?.contEndDate),
      deposit: res?.rental?.deposit,
      paymentMethod: res?.rental?.paymentMethod,
      totalAmount: res?.rental?.totalAmount,
      noOfInstallments: res?.rental?.noOfInstallments,
      annualRentAmount: res?.rental?.annualRentAmount,
      diplomatic: res?.diplomatic,
      government: res?.government,
      companyName: res?.company?.companyName,
      companyNameAr: res?.company?.companyNameAr,
      tradeLicenseNo: res?.company?.tradeLicenseNo,
      CompanyRejectionReason: res?.company?.rejectionReason,
      primaryLessorName: res?.primaryLessor?.name,
      primaryLessorNameAr: res?.primaryLessor?.nameAr,
      primaryLessorMobileNumber: res?.primaryLessor?.mobileNumber,
      primaryLessorEmail: res?.primaryLessor?.email,
      municipalityCharges: res?.municipalityCharges,
      propertyId: res?.property?.plotId,
      isTenant: res?.tenant,
      representativeName: res?.company?.repName,
      tenantName: res?.individual?.tenName,
      tenantNameAr: res?.individual?.tenNameAr,
      tenantRejectionReason: res?.individual?.rejectionReason,
      ...cleverTapOwnerPayload,
    };

    if (isPayment) {
      redirection(propertyDetail, res, id, `/app/applications/lease-payment/${id}`, isPayment);
    }
    if (type === 'closure-action') {
      res.applicationAction = await LeaseApplicationService.leaseClosure(id, {
        secondPartyApprovalRequired,
      }); // lease closure
      CleverTapTaskReviewApplicationInItCloseEvent({
        ...cleverTapGenericPayload,
        screenName: `screen_${res?.applicationDetails?.applicationType}_view`,
        stepName: '',
      });
      redirection(propertyDetail, { ...res, showSubTitle: true }, id, '/app/services/lease-expiration-success');
    }
    if (type === 'cancellation-action') {
      CleverTapTaskReviewApplicationCancelEvent({
        ...cleverTapGenericPayload,
        screenName: `screen_${res?.applicationDetails?.applicationType}_view`,
        stepName: '',
      });
      res.applicationAction = await LeaseApplicationService.leaseCancellation(id, actionParams); // lease cancellation
      redirection(propertyDetail, { ...res, showSubTitle: true }, id, '/app/services/lease-surrender-success');
    }

    if (type === 'termination-action') {
      CleverTapTaskReviewApplicationResubmitEvent({
        ...cleverTapGenericPayload,
        screenName: `screen_${res?.applicationDetails?.applicationType}_view`,
        stepName: '',
      });
      res.applicationAction = await LeaseApplicationService.leaseTerminationCourtOrder(id, actionParams); // lease cancellation
      redirection(propertyDetail, res, id, '/app/services/lease-termination-court-order-success');
    }
    if (type !== 'cancellation-action' && type !== 'termination-action' && actionParams != null) {
      if (actionParams?.approval) {
        CleverTapTaskReviewApplicationAcceptEvent({
          ...cleverTapGenericPayload,
        });
      } else if (actionParams?.rejection) {
        CleverTapTaskReviewApplicationReturnEvent({
          ...cleverTapGenericPayload,
          tenantRejectionReason: actionParams?.rejection,
        });
      } else {
        CleverTapTaskReviewApplicationTerminateEvent({
          ...cleverTapGenericPayload,
        });
      }
      CleverTapTaskReviewStatusViewEvent({
        applicationType: res?.applicationDetails?.applicationType,
        applicationStep: status,
      });
      // final owner
      if (type === 'owner') {
        const req = {
          applicationId: id,
          approved: actionParams?.approval,
          terminationReason: actionParams.rejection,
        };
        res.applicationAction = await LeaseApplicationService.leaseApplicationActionOwner(req); // owner action
        if (res?.applicationAction?.success) {
          if (actionParams?.approval) {
            CleverTapTaskReviewApplicationAcceptSuccessEvent({
              ...cleverTapGenericPayload,
            });

            redirection(propertyDetail, res, id, '/app/applications/lease/owner-approval');
          } else {
            CleverTapTaskReviewApplicationTerminateSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, res, id, '/app/applications/lease/owner-termination');
          }
        }
      } else if (type === 'otherOwner') {
        // other owner
        const req = {
          applicationId: id,
          approved: actionParams?.approval,
          rejectionReason: actionParams.rejection,
        };
        res.applicationAction = await LeaseApplicationService.leaseApplicationActionOtherOwner(req); // owner action
        if (res?.applicationAction?.success) {
          if (actionParams?.approval) {
            CleverTapTaskReviewApplicationAcceptSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, { ...res, showSubTitle: true }, id, '/app/applications/lease/lessee-approval');
          } else {
            CleverTapTaskReviewApplicationReturnSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, res, id, '/app/applications/lease/tenant-reject');
          }
        }
      } else if (type === 'tenant-cancel') {
        // cancellation tenant
        const req = {
          applicationId: id,
          approved: actionParams?.approval,
          rejectionReason: actionParams.rejection,
        };
        res.applicationAction = await LeaseApplicationService.leaseCancellationTenantApproval(req); // owner action
        if (res?.applicationAction?.success) {
          if (actionParams?.approval) {
            CleverTapTaskReviewApplicationAcceptSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, res, id, '/app/applications/lease-surrender/tenant-approval');
          } else {
            CleverTapTaskReviewApplicationRejectSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, res, id, '/app/applications/lease/surrender-reject');
          }
        }
      } else if (type === 'otherOwner-cancel') {
        // cancellation owner
        const req = {
          applicationId: id,
          approved: actionParams?.approval,
          rejectionReason: actionParams.rejection,
          terminationReason: actionParams.rejection,
        };
        res.applicationAction = await LeaseApplicationService.leaseCancellationOwnerApproval(req); // owner action
        // if (actionParams.approval) {
        //   res.applicationAction = await LeaseApplicationService.leaseCancellationOwnerApproval(req); // owner action
        // } else {
        //   res.applicationAction = await WorkflowService.cancelApplication(id, { status: 'CANCEL' });
        // }

        if (res?.applicationAction?.success) {
          if (actionParams?.approval) {
            CleverTapTaskReviewApplicationAcceptSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(
              propertyDetail,
              { ...res, showSubTitle: true },
              id,
              '/app/applications/lease-surrender/owner-approval',
            );
          } else {
            CleverTapTaskReviewApplicationRejectSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, res, id, '/app/applications/lease/surrender-reject');
          }
        }
      } else if (type === 'owner-cancel-final') {
        // cancellation owner

        res.applicationAction = await WorkflowService.cancelApplication(id, {
          status: 'CANCEL',
        });

        if (res?.applicationAction?.success) {
          CleverTapTaskReviewApplicationTerminateSuccessEvent({
            ...cleverTapGenericPayload,
          });
          redirection(propertyDetail, res, id, '/app/applications/lease/owner-termination');
        }
      } else if (type === 'tenant-closure') {
        // cancellation tenant
        const req = {
          applicationId: id,
          approved: actionParams?.approval,
          rejectionReason: actionParams.rejection,
        };
        res.applicationAction = await LeaseApplicationService.leaseClosureTenant(req); // owner action
        if (res?.applicationAction?.success) {
          if (actionParams?.approval) {
            CleverTapTaskReviewApplicationAcceptSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(
              propertyDetail,
              { ...res, showSubTitle: true },
              id,
              '/app/applications/lease-expiration/tenant-approval',
            );
          } else {
            CleverTapTaskReviewApplicationRejectSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, res, id, '/app/applications/lease/expiration-reject');
          }
        }
      } else if (type === 'owner-closure') {
        // closure owner
        const req = {
          applicationId: id,
          approved: actionParams?.approval,
          rejectionReason: actionParams.rejection,
          terminationReason: actionParams.rejection,
        };
        res.applicationAction = await LeaseApplicationService.leaseClosureOwner(req); // owner action

        if (res?.applicationAction?.success) {
          if (actionParams?.approval) {
            CleverTapTaskReviewApplicationAcceptSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(
              propertyDetail,
              { ...res, showSubTitle: true },
              id,
              '/app/applications/lease-expiration/owner-approval',
            );
          } else {
            CleverTapTaskReviewApplicationRejectSuccessEvent({
              ...cleverTapGenericPayload,
            });
            // returned screen
            redirection(propertyDetail, res, id, '/app/applications/lease/expiration-reject');
          }
        }
      } else if (type === 'owner-closure-final') {
        // closure owner

        res.applicationAction = await WorkflowService.cancelApplication(id, {
          status: 'CANCEL',
        });

        if (res?.applicationAction?.success) {
          CleverTapTaskReviewApplicationTerminateSuccessEvent({
            ...cleverTapGenericPayload,
          });
          redirection(propertyDetail, res, id, '/app/applications/lease/owner-termination');
        }
      } else {
        // tenant
        const req = {
          applicationId: id,
          approved: actionParams?.approval,
          rejectionReason: actionParams.rejection,
        };

        res.applicationAction = await LeaseApplicationService.leaseApplicationActionTenant(req); // tenant action
        if (res?.applicationAction?.success) {
          if (actionParams?.approval) {
            CleverTapTaskReviewApplicationAcceptSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, { ...res, showSubTitle: true }, id, '/app/applications/lease/lessee-approval');
          } else {
            CleverTapTaskReviewApplicationReturnSuccessEvent({
              ...cleverTapGenericPayload,
            });
            redirection(propertyDetail, res, id, '/app/applications/lease/tenant-reject');
          }
        }
      }
    }
    res.propertyDetail = propertyDetail;
    res.documents = documents;

    dispatch(fetchApplicationSuccess(res));
  } catch (e) {
    dispatch(fetchApplicationError(e));
    const {
      LeaseApplicationReducer: { application },
    } = getState();

    const cleverTapOwnerPayload = {};
    application?.owners?.forEach((owner, index) => {
      const currentIndex = index;
      cleverTapOwnerPayload['ownerUserId_' + currentIndex] = owner?.eidOrUnified;
      cleverTapOwnerPayload['ownerNameTradeLicenseNumber_' + currentIndex] = owner?.tradeLicenseNumber;
      cleverTapOwnerPayload['ownerNameEn_' + currentIndex] = owner?.ownerNameEn;
      cleverTapOwnerPayload['ownerNameAr_' + currentIndex] = owner?.ownerNameAr;
      cleverTapOwnerPayload['ownerNameEmail_' + currentIndex] = owner?.email;
      cleverTapOwnerPayload['ownerNamePhone_' + currentIndex] = owner?.phoneNumber;
      cleverTapOwnerPayload['ownerRejectionReason_' + currentIndex] = owner?.rejectionReason;
      cleverTapOwnerPayload['ownerPartyType_' + currentIndex] = owner?.partyType;
    });
    const cleverTapGenericPayload = {
      screenName: 'screen_task_details_view',
      applicationStatus: application?.applicationDetails?.applicationStatus,
      applicationId: application?.applicationId,
      applicationNumber: application?.applicationDetails?.applicationNumber,
      applicationStep: status,
      progressStatus: application?.applicationDetails?.progressStatus,
      contractNumber: application?.contractNo,
      contractStartDate: application?.contractDetails?.dateOfSale,
      contractEndDate: application?.contractDetails?.projectCompletionDate,
      initiatorName: application?.applicationDetails?.initiatorName,
      initiatorNameAr: application?.applicationDetails?.initiatorNameAr,
      gracePeriod: application?.rental?.gracePeriod,
      ContractActualEndDate: convertStringToDate(application?.rental?.contEndDate),
      deposit: application?.rental?.deposit,
      paymentMethod: application?.rental?.paymentMethod,
      totalAmount: application?.rental?.totalAmount,
      noOfInstallments: application?.rental?.noOfInstallments,
      annualRentAmount: application?.rental?.annualRentAmount,
      diplomatic: application?.diplomatic,
      government: application?.government,
      companyName: application?.company?.companyName,
      companyNameAr: application?.company?.companyNameAr,
      tradeLicenseNo: application?.company?.tradeLicenseNo,
      CompanyRejectionReason: application?.company?.rejectionReason,
      primaryLessorName: application?.primaryLessor?.name,
      primaryLessorNameAr: application?.primaryLessor?.nameAr,
      primaryLessorMobileNumber: application?.primaryLessor?.mobileNumber,
      primaryLessorEmail: application?.primaryLessor?.email,
      municipalityCharges: application?.municipalityCharges,
      propertyId: application?.property?.plotId,
      isTenant: application?.tenant,
      representativeName: application?.company?.repName,
      tenantName: application?.individual?.tenName,
      tenantNameAr: application?.individual?.tenNameAr,
      tenantRejectionReason: application?.individual?.rejectionReason,
      ...cleverTapOwnerPayload,
    };
    if (actionParams?.approval) {
      CleverTapTaskReviewApplicationAcceptFailureEvent({
        ...cleverTapGenericPayload,
        errorMessage: e?.message,
        errorCode: e?.statusCode,
      });
    } else if (actionParams?.rejection) {
      CleverTapTaskReviewApplicationRejectFailureEvent({
        ...cleverTapGenericPayload,
        errorMessage: e?.message,
        errorCode: e?.statusCode,
      });
    }
  }
};

export const fetchApplicationById = id => async dispatch => {
  try {
    dispatch({ type: types.FINAL_LEASE_SUCCESS_DATA });

    // fetch application
    const response = await LeaseApplicationService.fetchLeaseApplication(id);
    const res = response?.data?.result || response?.result;

    // property
    const propertyDetail = await fetchPropertyDetail(res?.property?.plotId);

    res.propertyDetail = propertyDetail;

    const propertyObj = {};
    const enObj = {
      applicationId: id,
      title: getTitle(propertyDetail?.en?.type, propertyDetail?.en),
      type: propertyDetail?.en?.type,
      tenantName: res?.individual?.tenName || res?.company?.companyName || null,
      duration: `${moment(res?.rental?.contStartDate).format('DD/MM/YYYY')} - ${moment(res?.rental?.contEndDate)
        .add(res?.rental?.gracePeriod || 0, 'days')
        .format('DD/MM/YYYY')}`,
    };
    const arObj = {
      applicationId: id,
      title: getTitle(propertyDetail?.ar?.type, propertyDetail?.ar),
      type: propertyDetail?.ar?.type,
      tenantName: res?.individual?.tenName || res?.company?.companyName || null,
      duration: `${moment(res?.rental?.contStartDate).format('DD/MM/YYYY')} - ${moment(res?.rental?.contEndDate)
        .add(res?.rental?.gracePeriod || 0, 'days')
        .format('DD/MM/YYYY')}`,
    };
    propertyObj.en = enObj;
    propertyObj.ar = arObj;
    dispatch({
      type: types.FINAL_LEASE_SUCCESS_DATA_SUCCESS,
      payload: {
        application: propertyObj,
      },
    });
  } catch (e) {
    dispatch({
      type: types.FINAL_LEASE_SUCCESS_DATA_ERROR,
      payload: {
        error: e,
      },
    });
  }
};
export const fetchWorkflowHistoryByApplicationId = id => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LEASE_WORKFLOW_HISTORY });
    // fetch application
    const response = await WorkflowService.fetchWorkflowHistoryV2(id);
    const res = response?.data?.result || response?.result;
    dispatch({
      type: types.FETCH_LEASE_WORKFLOW_HISTORY_SUCCESS,
      payload: {
        workflowHistory: res,
      },
    });
  } catch (e) {
    dispatch({
      type: types.FETCH_LEASE_WORKFLOW_HISTORY_SUCCESS,
      payload: {
        workflowHistory: [],
      },
    });
  }
};

export const cancelApplication = (id, params = { status: 'CANCEL', reason: '' }, type) => async (
  dispatch,
  getState,
) => {
  const { application } = getState().LeaseApplicationReducer;
  const cleverTapPayload = {
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationDetails?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationType: application?.applicationDetails?.applicationType,
    contractNumber: application?.contractNo,
    contractStartDate: application?.rental?.contStartDate,
    contractEndDate: application?.rental?.contEndDate,
  };
  const cleverTapOwnerPayload = {};
  application?.owners?.forEach((owner, index) => {
    const currentIndex = index;
    cleverTapOwnerPayload['ownerUserId_' + currentIndex] = owner?.eidOrUnified;
    cleverTapOwnerPayload['ownerNameTradeLicenseNumber_' + currentIndex] = owner?.tradeLicenseNumber;
    cleverTapOwnerPayload['ownerNameEn_' + currentIndex] = owner?.ownerNameEn;
    cleverTapOwnerPayload['ownerNameAr_' + currentIndex] = owner?.ownerNameAr;
    cleverTapOwnerPayload['ownerNameEmail_' + currentIndex] = owner?.email;
    cleverTapOwnerPayload['ownerNamePhone_' + currentIndex] = owner?.phoneNumber;
    cleverTapOwnerPayload['ownerRejectionReason_' + currentIndex] = owner?.rejectionReason;
    cleverTapOwnerPayload['ownerPartyType_' + currentIndex] = owner?.partyType;
  });
  const cleverTapGenericPayload = {
    screenName: 'screen_task_details_view',
    initiatorName: application?.applicationDetails?.initiatorName,
    initiatorNameAr: application?.applicationDetails?.initiatorNameAr,
    gracePeriod: application?.rental?.gracePeriod,
    ContractActualEndDate: convertStringToDate(application?.rental?.contEndDate),
    deposit: application?.rental?.deposit,
    paymentMethod: application?.rental?.paymentMethod,
    totalAmount: application?.rental?.totalAmount,
    noOfInstallments: application?.rental?.noOfInstallments,
    annualRentAmount: application?.rental?.annualRentAmount,
    diplomatic: application?.diplomatic,
    government: application?.government,
    companyName: application?.company?.companyName,
    companyNameAr: application?.company?.companyNameAr,
    tradeLicenseNo: application?.company?.tradeLicenseNo,
    CompanyRejectionReason: application?.company?.rejectionReason,
    primaryLessorName: application?.primaryLessor?.name,
    primaryLessorNameAr: application?.primaryLessor?.nameAr,
    primaryLessorMobileNumber: application?.primaryLessor?.mobileNumber,
    primaryLessorEmail: application?.primaryLessor?.email,
    municipalityCharges: application?.municipalityCharges,
    propertyId: application?.property?.plotId,
    isTenant: application?.tenant,
    representativeName: application?.company?.repName,
    tenantName: application?.individual?.tenName,
    tenantNameAr: application?.individual?.tenNameAr,
    tenantRejectionReason: application?.individual?.rejectionReason,
    ...cleverTapOwnerPayload,
    applicationStep: type,
  };
  const cancelApplicationResponse = await WorkflowService.cancelApplication(id, params);
  try {
    dispatch({ type: types.LEASE_CANCEL_APPLICATION });
    CleverTapCancelApplicationDetails(cleverTapPayload);
    if (params?.status === 'REJECT') {
      CleverTapTaskReviewApplicationTerminateEvent({
        ...cleverTapGenericPayload,
      });
    } else {
      CleverTapTaskReviewApplicationTerminateEvent({
        ...cleverTapGenericPayload,
      });
    }
    CleverTapTaskReviewStatusViewEvent({
      applicationType: application?.applicationDetails?.applicationType,
      applicationStep: type,
    });

    if (params?.status === 'REJECT') {
      const propertyDetail = await fetchPropertyDetail(application?.property?.plotId);
      redirection(propertyDetail, application, id, '/app/applications/lease/approval/reject-success');
    }
    dispatch({
      type: types.LEASE_CANCEL_APPLICATION_SUCCESS,
    });
    CleverTapCancelApplicationDetailsSuccess(cleverTapPayload);
    if (params?.status === 'REJECT') {
      CleverTapTaskReviewApplicationRejectSuccessEvent({
        ...cleverTapGenericPayload,
      });
    } else {
      CleverTapTaskReviewApplicationTerminateSuccessEvent({
        ...cleverTapGenericPayload,
      });
    }
    if (params?.status === 'CANCEL') {
      if (cancelApplicationResponse?.success) {
        const propertyDetail = await fetchPropertyDetail(application?.property?.plotId);
        redirection(propertyDetail, application, id, '/app/applications/lease/owner-termination');
      }
    }
    if (params?.status === 'DISCARD') {
      if (cancelApplicationResponse?.success) {
        history.push('/app/applications');
      }
    }
  } catch (e) {
    cleverTapPayload.errorCode = e?.statusCode;
    cleverTapPayload.errorMessage = e?.data?.result?.description;
    dispatch({
      type: types.LEASE_CANCEL_APPLICATION_ERROR,
      payload: {
        error: e,
      },
    });
    CleverTapCancelApplicationDetailsFailure(cleverTapPayload);
    if (params?.status === 'REJECT') {
      CleverTapTaskReviewApplicationRejectFailureEvent({
        ...cleverTapGenericPayload,
        errorMessage: e?.message,
        errorCode: e?.statusCode,
      });
    }
  }
};

export const fetchFinalApplicationById = id => async dispatch => {
  try {
    dispatch({ type: types.FINAL_LEASE_SUCCESS_DATA });

    // fetch application
    const response = await LeaseApplicationService.fetchLeaseApplication(id);
    const res = response?.data?.result || response?.result;

    dispatch({
      type: types.FINAL_LEASE_SUCCESS_DATA_SUCCESS,
      payload: {
        application: res,
      },
    });
  } catch (e) {
    dispatch({
      type: types.FINAL_LEASE_SUCCESS_DATA_ERROR,
      payload: {
        error: e,
      },
    });
  }
};
